import { Endpoint } from '../endpoint';
import {
  ManagementFormID,
  ManagementFormCommentResponse,
  CommentId,
  ManagementFormResponse,
  PostManagementFormCommentPayload,
} from '@business/entities/managementForms';
import { UserId } from '@business/entities/account';

export function fetchComments(formId: ManagementFormID, isCompact?: boolean) {
  return Endpoint.get<ManagementFormCommentResponse[]>(`@gc/management-form-comments/${formId}`, { params: { isCompact } });
}

export function fetchComment(id: CommentId) {
  return Endpoint.get<ManagementFormCommentResponse>(`@gc/management-form-comments/comment/${id}`);
}

export function createComment(data: PostManagementFormCommentPayload) {
  return Endpoint.post<ManagementFormResponse>(`@gc/management-form-comments`, { data });
}

export function deleteComment(commentId: CommentId) {
  return Endpoint.delete<void>(`@gc/management-form-comments/${commentId}`);
}
